import { isCoach } from "@/components/helpers/workspace/permissions";
import { useAuth } from "@/components/lib/auth";
import { isImpersonating } from "@/components/session/JwtTokenManager";

/**
 * Checks if the current user can view all timeslots.
 * Useful to check a coach's schedule settings.
 *
 * @param coachId - The ID of the coach.
 * @returns True if the current user can use all timeslots, false otherwise.
 */
export function canViewAllTimes(coachId?: string): boolean {
  if (!coachId) return false;

  const { currentUser } = useAuth();

  if (currentUser.isStaff || currentUser.isSuperuser) {
    return true;
  }

  if (isCoach() && coachId == currentUser.id) {
    return true;
  }

  if (isImpersonating() && !currentUser.isAgent) {
    return true;
  }

  return false;
}
